import { CalendarEventChip } from '@/modules/calendar/components/CalendarEventChip';
import type { CalendarEvent } from '@/modules/calendar/types';
import {
  eventsForDay,
  formatDayNumber,
  formatWeekday,
  getMonthGridDays,
} from '@/modules/calendar/utils';

const WEEKDAYS = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

type CalendarMonthViewProps = {
  anchorDate: string;
  events: CalendarEvent[];
};

export function CalendarMonthView({ anchorDate, events }: CalendarMonthViewProps) {
  const cells = getMonthGridDays(anchorDate);

  return (
    <div className="calendar-month">
      <div className="calendar-month__head">
        {WEEKDAYS.map((d) => (
          <span key={d} className="calendar-month__weekday">
            {d}
          </span>
        ))}
      </div>
      <div className="calendar-month__grid">
        {cells.map((cell) => {
          const dayEvents = eventsForDay(events, cell.iso);
          const visible = dayEvents.slice(0, 3);
          const more = dayEvents.length - visible.length;
          return (
            <div
              key={cell.iso}
              className={
                cell.inCurrentMonth
                  ? 'calendar-month__cell'
                  : 'calendar-month__cell calendar-month__cell--muted'
              }
            >
              <span className="calendar-month__day" title={formatWeekday(cell.iso)}>
                {formatDayNumber(cell.iso)}
              </span>
              <div className="calendar-month__events">
                {visible.map((ev) => (
                  <CalendarEventChip key={`${cell.iso}-${ev.id}`} event={ev} compact />
                ))}
                {more > 0 ? (
                  <span className="calendar-month__more">+{more} más</span>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
